import { LocalizationService } from 'src/app/service/localization.service';
import { JsonKey, JsonKeyCode } from '../data/type/locale-copy-key';
import { RemoteButtonKey } from '../data/type/remote-button';
import { VoiceSearchFeature } from '../page/voice-search-page/voice-search-page.types';

export const getRotationHandlerCopy = (localizationService: LocalizationService) => ({
  [JsonKey.WELCOME_ROTATE_DEVICE_COPY]: localizationService.translate(
    JsonKey.WELCOME_ROTATE_DEVICE_COPY,
  ),
});

export const getCompareModalCopy = (localizationService: LocalizationService) => ({
  [JsonKey.CLOSE_BUTTON_ARIA_LABEL]: localizationService.translate(JsonKey.CLOSE_BUTTON_ARIA_LABEL),
  [JsonKey.COMPARE_MODAL_ARIA_LABEL]: localizationService.translate(
    JsonKey.COMPARE_MODAL_ARIA_LABEL,
  ),
});

export const getWelcomePageCopy = (localizationService: LocalizationService) => ({
  [JsonKey.WELCOME_PRIMARY_BUTTON_COPY]: localizationService.translate(
    JsonKey.WELCOME_PRIMARY_BUTTON_COPY,
  ),
  [JsonKey.WELCOME_SECONDARY_BUTTON_3P_COPY]: localizationService.translate(
    JsonKey.WELCOME_SECONDARY_BUTTON_3P_COPY,
  ),
  [JsonKey.WELCOME_PRIMARY_BUTTON_ARIA_LABEL]: localizationService.translate(
    JsonKey.WELCOME_PRIMARY_BUTTON_ARIA_LABEL,
  ),
});

export const getNavigationCopy = (localizationService: LocalizationService) => ({
  [JsonKey.NAVIGATION_LINK_1]: localizationService.translate(JsonKey.NAVIGATION_LINK_1),
  [JsonKey.NAVIGATION_LINK_2]: localizationService.translate(JsonKey.NAVIGATION_LINK_2),
  [JsonKey.NAVIGATION_LINK_3]: localizationService.translate(JsonKey.NAVIGATION_LINK_3),
  [JsonKey.NAVIGATION_LINK_4]: localizationService.translate(JsonKey.NAVIGATION_LINK_4),
  [JsonKey.NAVIGATION_OPEN_ARIA_LABEL]: localizationService.translate(
    JsonKey.NAVIGATION_OPEN_ARIA_LABEL,
  ),
  [JsonKey.NAVIGATION_CLOSE_ARIA_LABEL]: localizationService.translate(
    JsonKey.NAVIGATION_CLOSE_ARIA_LABEL,
  ),
});

export const getMoreInfoCopy = (
  localizationService: LocalizationService,
  featureMoreInfoTitleKey: JsonKeyCode,
  featureMoreInfoMainCopyKey: JsonKeyCode,
  featureMoreInfoLegalFooterKey: JsonKeyCode,
) => ({
  [JsonKey.CLOSE_BUTTON_ARIA_LABEL]: localizationService.translate(JsonKey.CLOSE_BUTTON_ARIA_LABEL),
  [JsonKey.MORE_INFO_ARIA_LABEL]: localizationService.translate(JsonKey.MORE_INFO_ARIA_LABEL),
  [JsonKey.MORE_INFO_EYEBROW]: localizationService.translate(JsonKey.MORE_INFO_EYEBROW),
  [JsonKey[featureMoreInfoMainCopyKey]]: localizationService.translate(
    JsonKey[featureMoreInfoMainCopyKey],
  ),
  [JsonKey[featureMoreInfoTitleKey]]: localizationService.translate(
    JsonKey[featureMoreInfoTitleKey],
  ),
  [JsonKey[featureMoreInfoLegalFooterKey]]: localizationService.translate(
    JsonKey[featureMoreInfoLegalFooterKey],
  ),
});

export const getDisclaimerCopy = (
  localizationService: LocalizationService,
  featureDisclaimerCopy: JsonKeyCode,
) => ({
  [JsonKey[featureDisclaimerCopy]]: localizationService.translate(JsonKey[featureDisclaimerCopy]),
});

export const getEndScreenCopy = (
  localizationService: LocalizationService,
  titleKey: JsonKeyCode,
  copyKey: JsonKeyCode,
) => ({
  [titleKey]: localizationService.translate(JsonKey[titleKey]),
  [copyKey]: localizationService.translate(JsonKey[copyKey]),
});

export const getCompareButtonCopy = (localizationService: LocalizationService) => ({
  [JsonKey.NAVIGATION_COMPARE]: localizationService.translate(JsonKey.NAVIGATION_COMPARE),
});

export const getSpecsFooterCopy = (localizationService: LocalizationService) => [
  localizationService.translate(JsonKey.SPECS_FOOTER_COPY_1),
  localizationService.translate(JsonKey.SPECS_FOOTER_COPY_2),
];

export const getRemoteControlCopy = (localizationService: LocalizationService) => ({
  [RemoteButtonKey.up]: localizationService.translate(JsonKey.REMOTE_CONTROL_UP),
  [RemoteButtonKey.down]: localizationService.translate(JsonKey.REMOTE_CONTROL_DOWN),
  [RemoteButtonKey.left]: localizationService.translate(JsonKey.REMOTE_CONTROL_LEFT),
  [RemoteButtonKey.right]: localizationService.translate(JsonKey.REMOTE_CONTROL_RIGHT),
  [RemoteButtonKey.center]: localizationService.translate(JsonKey.REMOTE_CONTROL_CENTER),
  [RemoteButtonKey['center-hisense']]: localizationService.translate(JsonKey.REMOTE_CONTROL_CENTER),
});

export const getAudioResponseCopy = (localizationService: LocalizationService) => ({
  [JsonKey.AUDIO_RESPONSE_ERROR]: localizationService.translate(JsonKey.AUDIO_RESPONSE_ERROR),
  [JsonKey.AUDIO_RESPONSE_LIGHTS]: localizationService.translate(JsonKey.AUDIO_RESPONSE_LIGHTS),
  [JsonKey.AUDIO_RESPONSE_LIGHTS]: localizationService.translate(JsonKey.AUDIO_RESPONSE_LIGHTS),
  [JsonKey.AUDIO_RESPONSE_FRONT_DOOR]: localizationService.translate(
    JsonKey.AUDIO_RESPONSE_FRONT_DOOR,
  ),
});

export const getSpeechButtonCopy = (localizationService: LocalizationService) => ({
  [JsonKey.SPEECH_BUTTON_ARIA_LABEL]: localizationService.translate(
    JsonKey.SPEECH_BUTTON_ARIA_LABEL,
  ),
});

export const getVoiceIntroCopy = (LocalizationService: LocalizationService) => ({
  [JsonKey.VOICE_INTRO_PLEASE_WAIT]: LocalizationService.translate(JsonKey.VOICE_INTRO_PLEASE_WAIT),
  [JsonKey.VOICE_INTRO_TRY_SAYING_COPY]: LocalizationService.translate(
    JsonKey.VOICE_INTRO_TRY_SAYING_COPY,
  ),
  [JsonKey.VOICE_INTRO_CHOOSE_ONE_COPY]: LocalizationService.translate(
    JsonKey.VOICE_INTRO_CHOOSE_ONE_COPY,
  ),
  featureTitles: {
    [VoiceSearchFeature['action-movies']]: LocalizationService.translate(
      JsonKey.VOICE_INTRO_FEATURE_1,
    ),
    [VoiceSearchFeature['lights']]: LocalizationService.translate(JsonKey.VOICE_INTRO_FEATURE_2),
    [VoiceSearchFeature['children-shows']]: LocalizationService.translate(
      JsonKey.VOICE_INTRO_FEATURE_3,
    ),
    [VoiceSearchFeature['front-door']]: LocalizationService.translate(
      JsonKey.VOICE_INTRO_FEATURE_4,
    ),
  },
});
